export function jsonToFormData(obj, form, namespace) {
  const fd = form || new FormData();
  let formKey;
  for (const property in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, property)) {
      if (namespace) {
        formKey = namespace + "." + property;
      } else {
        formKey = property;
      }
      if (typeof obj[property] === "boolean") {
        fd.append(formKey, obj[property]);
      } else if (Array.isArray(obj[property])) {
        for (let i = 0; i < obj[property].length; i++) {
          fd.append(formKey, obj[property][i]);
        }
      } else if (typeof obj[property] === "object" && !isFile(obj[property])) {
        jsonToFormData(obj[property], fd, property);
      } else if (isFile(obj[property])) {
        fd.append(formKey, obj[property], obj[property].name);
      } else if (obj[property]) {
        fd.append(formKey, obj[property]);
      } else if (!obj[property]) {
        fd.append(formKey, "");
      }
    }
  }
  return fd;
}

export function isFile(object) {
  return object instanceof File || object instanceof Blob;
}
